<div class="offer-coupon-container">
  <div class="value">
    <span class="offer-value">{{ this.title }}</span>
  </div>
  <div class="text">
    <div class="offer-coupon-title" [innerHtml]="'fidelity-info.offer-coupon.title' | translate"></div>
    <div class="offer-coupon-subtitle" [innerHtml]="'fidelity-info.offer-coupon.subtitle' | translate"></div>
    <div
      class="offer-coupon-date"
      [innerHtml]="'fidelity-info.offer-coupon.date' | translate: { date: this.formatedExpirationDate }"></div>
  </div>
</div>
